// Module
var code = "<md-input-container>\n    <label></label>\n    <input type=\"text\" ng-model-options=\"{updateOn: 'blur'}\" />\n</md-input-container>";
// Exports
module.exports = code;